<div style="
        height: 100%;
        display: flex;
        flex-flow: column;
        background-color: var(--app-surface);
    ">
    <mat-toolbar color="primary" style="position: relative; z-index: 3">
        <span class="left">{{ actualProduct?.name }}</span>
        <button mat-icon-button class="back text-on-primary" (click)="goBack.emit()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>
    <div *ngIf="this.displaySpinner">
        <mat-spinner></mat-spinner>
    </div>
    <mat-tab-group *ngIf="!this.displaySpinner" class="organisation-tabs" [backgroundColor]="'primary'">
        <mat-tab label="Übersicht">
            <div class="organisation-hero">
                <app-image-slider [item]="this.actualProduct" [category]="'organisation'"></app-image-slider>
            </div>
            <div class="organisation-overview">
                <div class="organisation-summary">
                    <h1 [class]="actualProduct?.name.length > 45 ? 'wordellipsis' : ''">
                        {{ actualProduct?.name }}
                    </h1>
                    <div class="organisation-actions" *ngIf="this.organisation?.website != null">
                        <button *ngIf="
                                this.organisation?.organisationType?.includes(
                                    OrganisationType.PRODUCT_PROVIDER
                                ) ||
                                this.organisation?.organisationType?.includes(
                                    OrganisationType.DATASPACE_PARTICIPANT
                                )
                            " mat-raised-button (click)="
                                routeToProducts(OrganisationType.PRODUCT_PROVIDER)
                            " color="accent" style="margin: 2px">
                            Produkte
                        </button>
                        <!-- TODO  evtl. noch fuer die anderen Typen von Organisationen    CERTIFICATION_OFFICE & PRODUCT_TYPE_ASSOCIATION  -->
                        <button *ngIf="
                                this.organisation?.organisationType?.includes(
                                    OrganisationType.CERTIFICATION_PROVIDER
                                ) ||
                                this.organisation?.organisationType?.includes(
                                    OrganisationType.CERTIFICATION_OFFICE
                                )
                            " mat-raised-button (click)="
                                routeToProducts(OrganisationType.CERTIFICATION_PROVIDER)
                            " color="accent" style="margin: 2px">
                            Zertifikate
                        </button>

                        <button mat-raised-button [disabled]="
                                this.organisation?.website == null ||
                                this.organisation?.website == undefined ||
                                this.organisation?.website == ''
                            " mat-raised-button (click)="routeToWebsite()" color="accent">
                            Organisationswebseite
                        </button>
                    </div>
                </div>
                <mat-divider></mat-divider>
                <section class="organisation-description">
                    <h3>Organisationsbeschreibung</h3>
                    <p class="word-wrap" [innerHTML]="actualProduct?.description"></p>
                </section>
            </div>
        </mat-tab>
        <mat-tab label="Wallet">
            <div class="padding">
                <app-certificates-component
                    [walletOwnerId]="actualProduct?.organisationId">
                </app-certificates-component>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
